// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----organizers-module---root---1A3Ao","organizer":"src-components----organizers-module---organizer---3hvW3","photo":"src-components----organizers-module---photo---1ItF0","info":"src-components----organizers-module---info---3AIfi","name":"src-components----organizers-module---name---1bzai","twitter":"src-components----organizers-module---twitter---2PpXL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organizers.module.scss
// module id = 447
// module chunks = 263791100135453